import { IAuditionScheduleGroupAttributes } from 'shared/interfaces/IAuditionScheduleGroup';

export const getIsViewedAudition = (auditionScheduleGroups: IAuditionScheduleGroupAttributes[]) => {
  return auditionScheduleGroups.filter((value) => value.viewed).length > 0;
};
